// extracted by mini-css-extract-plugin
export default {"panjabiFont":"pfont_panjabiFont__72QjC"};